<template>
  <view class="share-container">
    <Navbar isFixed useDefaultBack="{{false}}" navbarStyle="{{navbarStyle}}" bind:clickleft="gohome" />
    <image
      class="main-bg"
      wx:class="{{hideNavBar && 'lestop'}}"
      src="https://ut-static.udache.com/webx/sfc/q8zndB0RoZ8-Vf2sfE06i.png"
      mode="widthFix"
    />
    <image
      class="main-gif"
      wx:class="{{hideNavBar && 'lestop'}}"
      src="https://ut-static.udache.com/webx/sfc/Ex-qwZBl0s7n2PlPnTagb.gif"
      mode="widthFix"
    />
    <view class="main-content" wx:class="{{hideNavBar && 'lestop'}}">
      <view class="help-coupon-list">
        <view class="help-coupon-list-title">
          <view class="normal-status" wx:if="{{status === 0}}">
            <image
              class="pic"
              src="https://ut-static.udache.com/webx/sfc/WTplWGsRIqvuRagGZtdYa.png"
              mode="heightFix"
            />
            <view class="text">{{ totalAmount }}</view>
            <image
              class="pic"
              src="https://ut-static.udache.com/webx/sfc/T8MjIff8RzLkw-XBbpO_k.png"
              mode="heightFix"
            />
          </view>
          <image wx:else class="picb" src="{{titlePic}}" mode="heightFix" />
        </view>
        <view class="reward-coupon-wrapper">
          <view
            class="reward-coupon-item"
            wx:class="{{{'overdue': status === 2}}}"
            wx:for="{{rewardCouponList}}"
          >
            <image class="reward-coupon-item-cornermark" src="{{cornermarkPic}}" />
            <view class="reward-coupon-item-left" wx:class="{{{'overdue': status === 2}}}">
              <view class="price" wx:class="{{{'overdue': status === 2}}}">
                <view class="num">{{ getAmount(item) }}</view>
                <view class="unit">元</view>
              </view>
            </view>
            <view class="reward-coupon-item-right">
              <view wx:if="{{item.name}}" class="name" wx:class="{{{'overdue': status === 2}}}">{{ item.name }}</view>
              <view wx:if="{{item.remark}}" class="remark" wx:class="{{{'overdue': status === 2}}}">{{ item.remark }}</view>
            </view>
          </view>
        </view>
        <image class="help-btn" src="{{helpBtnPic}}" mode="heightFix" bindtap="assist" />
      </view>
      <image
        class="share-guide"
        src="https://ut-static.udache.com/webx/sfc/wcTxsLUSvfHWtO5TMfZUf.png"
        mode="widthFix"
      />
      <view class="dd-logo-wrapper">
        <image
          class="dd-logo"
          src="https://ut-static.udache.com/webx/sfc/Jpr5FbYElgbPq60oNurO6.png"
        />
      </view>
    </view>
    <success-popup
      isPopupShow="{{isPopupShow}}"
      totalAmount="{{totalAmount}}"
      rewardCouponList="{{rewardCouponList}}"
      bind:close="requestFresh"
      bind:receive="receiveCoupon"
    />
  </view>
</template>


<script>
  import { createPage, mpx } from '@didi/es-mpx-creator'
  import { getAccShareContentApi, accPacStatusUpdateApi } from '@/api/package'
  import { getFinalPrice } from '@/utils/money'
  import { query, canIUse, subscribe, is } from '@didi/webx-js'
  import { trackEvent } from '@/common/track'
  import { innerRouter, pagePath } from '@/common/jump'
  import { SHARE_ACTIVITY_ID } from '@/config/falling-popup/constant'
  import { goTo } from '@didi/webx-js'
  import { getStorage } from '@/utils/storage'

  createPage({
    data: {
      navbarStyle: {
        background: 'transparent'
      },
      isPopupShow: false,
      rewardCouponList: [],
      status: 0, //助力状态 0 未助力   1 已助力   2不可助力
      toastMesssage: '',
    },
    async created() {
      await this.getAccShareContent()
      const from = query()?.share_from ?? ''
      const source = from === 'wxtimeline' ? 2 
        : from === 'wxappmsg' ? 1 : ''
      trackEvent('userteam_train_guestspeedup_sw', 'UT-客态加速h5页-曝光', {
        source
      })
      this.statusTrackFuc(0)
    },
    onShow() {
      if(this.toastMesssage && is('miniprogram.weixin')) {
         mpx.showToast({
           title: this.toastMesssage,
           icon: 'error',
           duration: 4000
         })
        this.toastMesssage = ''
      }
    },
    computed: {
      hideNavBar() {
        return is('miniprogram.weixin') || is('miniprogram.alipay')
      },
      totalAmount() {
        const amount = this.rewardCouponList?.reduce((pre, cur) => typeof cur.amount === 'number' && cur.amount + pre, 0) ?? 0
        return getFinalPrice(amount)
      },
      titlePic() {
        let pic = ''
        switch (this.status) {
          case 1:
            pic = 'https://ut-static.udache.com/webx/sfc/Dkg-bIGsLc6iuzmGq8_RI.png'
            break
          case 2:
            pic = 'https://ut-static.udache.com/webx/sfc/NuVQt2ccclgjC_BKcPEEY.png'
            break
          default:
            pic = ''
            break
        }
        return pic
      },
      cornermarkPic() {
        let pic = ''
        switch (this.status) {
          case 1:
            pic = 'https://ut-static.udache.com/webx/sfc/8293TWd8pklkQmLl7KOO8.png'
            break
          case 2:
            pic = 'https://ut-static.udache.com/webx/sfc/0lGCVrcsc7UBq_NJybVkH.png'
            break
          default:
            pic = ''
        }
        return pic
      },
      helpBtnPic() {
        let pic = ''
        switch (this.status) {
          case 0:
            pic = 'https://ut-static.udache.com/webx/sfc/Bpm04Uaboc8jUJbJBratd.png'
            break
          case 1:
            pic = 'https://ut-static.udache.com/webx/sfc/h7KJp_gNytENCa4sybkNk.png'
            break
          case 2:
            pic = 'https://ut-static.udache.com/webx/sfc/0MSmlxeb6VgvE2UjqTGy1.png'
            break
          default:
            pic = 'https://ut-static.udache.com/webx/sfc/Bpm04Uaboc8jUJbJBratd.png'
        }
        return pic
      }
    },
    methods: {
      closePopup() {
        this.isPopupShow = false
      },
      async requestFresh() {
        this.closePopup()
        await this.getAccShareContent()
        this.statusTrackFuc(1)
      },
      async getAccShareContent() {
        const order_id = query().order_id ?? ''
        const order_uid = query().order_uid ?? ''
        const params = {
          order_id,
          order_uid
        }
        await getAccShareContentApi(params).then((res) => {
          const { success, data, code } = res || {}
          if (success && +code === 0) {
            this.rewardCouponList = data.coupon_info ?? []
            this.status = +data.status ?? 0
          }
        })
      },
      getAmount(item) {
        return getFinalPrice(item.amount ?? 0)
      },
      gohome() {
        const dchn = is('miniprogram.weixin')
            ? 'p/X3e2Mwm'
            : 'w5rOn1W'
        goTo({ url: `https://v.didi.cn/${dchn}` })
      },
      assist() {
        if (this.status === 0) {
          const order_id = query().order_id ?? ''
          const order_uid = query().order_uid ?? ''
          const params = {
            status: 2,
            order_id,
            order_uid,
          }
          trackEvent('userteam_train_guestspeedup_help_ck', 'UT-客态加速h5页-助力按钮-点击', {})
          accPacStatusUpdateApi(params).then((res) => {
            const { code, data, success, message } = res
            if (success && +code === 0) {
              this.isPopupShow = true
            } else {
              mpx.showToast({
                title: message,
                icon: 'error',
                duration: 2000
              })
            }
          })
        } else {
          this.gohome()
        }
      },
      cusSubscribe() {
        if (!is('weixin')) return
        try {
          canIUse('subscribe') &&
            subscribe({ activity_id: SHARE_ACTIVITY_ID })
              .then((data) => {
                console.log('微信内嵌h5订阅成功 ', data)
              })
              .catch((error) => {
                console.log('微信内嵌h5订阅失败 ', error)
              })
        } catch (e) {
          console.log('拉起订阅失败', e)
        }
      },
      receiveCoupon() {
        this.cusSubscribe()
        const order_id = query().order_id ?? ''
        const order_uid = query().order_uid ?? ''
        const ticket = getStorage('token') || query().token ||  query().ticket || ''
        const params = {
          status: 3,
          order_id,
          order_uid,
          ticket
        }
        trackEvent('receive-coupon-token', '排查--领券token', { ticket })
        accPacStatusUpdateApi(params).then((res) => {
          const { code, data, success, message } = res
          if (success && +code === 0) {
            this.closePopup()
            mpx.showToast({
              title: '领取成功',
              icon: 'success',
              duration: 2000
            })
            setTimeout(() => {
              this.gohome()
            }, 1000)
          } else {
            this.closePopup()
            if(is('miniprogram.weixin')){
              this.toastMesssage = message
            }
            else {
              mpx.showToast({
                title: message,
                icon: 'error',
                duration: 4000
              })
            }
          }
        })
      },
      statusTrackFuc(time) {
        if(!this.status) return 
        const type = this.status === 2 ? 3 : this.status === 1 ? time === 0 ? 2 : 1 : ''
        trackEvent('userteam_train_guestspeedup_endpage_sw','UT-火车票-客态加速h5页-助力终态页-曝光',{type})
      },
    }
  })
</script>

<style lang='stylus' scoped>
  .share-container
    width 100%
    position relative
    overflow auto
    background #FF6F12
    .main-bg
      position absolute
      top 0
      left 0
      width 100%
      &.lestop
        top -44px
    .main-gif
      position absolute
      top 100px
      left 50%
      width 218px
      transform translateX(-50%)
      &.lestop
        top 56px
    .main-content
      width 100%
      padding 296px 16px 0 16px
      box-sizing border-box
      &.lestop
        padding-top 252px
      .help-coupon-list
        position relative
        width 100%
        background url('https://ut-static.udache.com/webx/sfc/siwAw7PrN3aNKa6kLCDHS.png')
        background-size cover
        background-repeat no-repeat
        height 403px
        display flex
        flex-direction column
        align-items center
        padding-top 4px
        box-sizing border-box
        border-radius 20px
        margin-bottom 7.5px
        padding 4px 12px
        .help-coupon-list-title
          display flex
          align-items center
          font-family Barlow Semi Condensed
          font-size 32px
          font-weight 400
          color #FF6427
          .normal-status
            display flex
            align-items center
          .pic
            height 22px
          .picb
            height 20px
            margin 15px 0
          .text
            line-height 45px
            margin 0 2px
        .reward-coupon-wrapper
          width 100%
          display flex
          flex-direction column
          align-items center
          margin-bottom 7.5px
          .reward-coupon-item
            width 100%
            position relative
            height 81px
            display flex
            align-items center
            background linear-gradient(264deg, #FFF5B5 -63%, #FFF9E7 67%, #FFFAEA 99%)
            box-sizing border-box
            border 1px solid #FFD69C
            border-radius 10px
            -webkit-mask radial-gradient(circle at 99px 4px, transparent 4px, #000 4px) 0 -3.8px
            mask radial-gradient(circle at 99px 4px, transparent 4px, #000 4px) 0 -3.8px
            &::before
              position absolute
              content ''
              width 6px
              height 6px
              top -3.9px
              left 94.2px
              border-radius 50%
              border 1px solid #FFD69C
            &::after
              position absolute
              content ''
              width 6px
              height 6px
              bottom -3.9px
              left 94.2px
              border-radius 50%
              border 1px solid #FFD69C
            &:not(:last-child)
              margin-bottom 10px
            &.overdue
              background #EBEBEB
              border-color #E2E2E2
            .reward-coupon-item-cornermark
              position absolute
              right 0
              top 0
              height 66px
              width 66px
              z-index 1
            .reward-coupon-item-left
              width 97.5px
              height 57.5px
              border-right 1px dotted #F7A774
              display flex
              justify-content center
              align-items center
              &.overdue
                border-color #B0B0B0
              .price
                display flex
                justify-content center
                align-items baseline
                color #FF6427
                &.overdue
                  color #999
                .num
                  font-family Barlow Semi Condensed
                  font-size 45px
                  font-weight 400
                  line-height 45px
                  letter-spacing 0px
                .unit
                  font-family PingFangSC-Regular
                  font-weight 400
                  font-size 16px
                  line-height 16px
                  text-align center
                  letter-spacing 0px
            .reward-coupon-item-right
              flex 1
              position relative
              z-index 2
              padding-left 20px
              display flex
              flex-direction column
              justify-content center
              .name
                font-family PingFangSC-Semibold
                font-size 16px
                font-weight 600
                line-height 16px
                letter-spacing 0px
                color #543018
                margin-bottom 5px
                &.overdue
                  color #999
              .remark
                font-family PingFangSC-Regular
                font-weight 400
                font-size 12px
                line-height 12px
                letter-spacing 0px
                color #B98664
                &.overdue
                  color #999
        .help-btn
          position absolute
          bottom 0
          left 50%
          transform translateX(-50%)
          height 80px
      .share-guide
        width 100%
      .dd-logo-wrapper
        width 100%
        display flex
        justify-content center
        margin 32px 0
        .dd-logo
          width 102px
          height 20px 
        
</style> 

<script name='json'>
    module.exports = {
      component: true,
      usingComponents: {
        'success-popup': './components/success-popup',
        Navbar: '@didi/spring-ui/ts-navbar'
      }
    }
</script>